import React, { useState } from "react";
import { useBotStore } from "../../stores/botStore";
import { useAuth } from "hooks/useAuth";

// Порядок відображення налаштувань у таблиці
const SettingsOrder = [
  "new_status_id",
  "stats_lookback_days",
  "phone_field_uuid",
  "phone_field_value",
  "day_shift_start",
  "day_shift_end",
  "wip_limit_day",
  "wip_limit_night",
];

// Мапа назв налаштувань
const SettingsNameMapper = {
  new_status_id: "ID статусу призначення",
  stats_lookback_days: "Кількість днів статистики",
  phone_field_uuid: "UUID поля 'Телефон'",
  phone_field_value: "Значення поля 'Телефон'",
  day_shift_start: "Початок денної зміни",
  day_shift_end: "Кінець денної зміни",
  wip_limit_day: "Ліміт замовлень (день)",
  wip_limit_night: "Ліміт замовлень (ніч)",
};

// Компонент таблиці налаштувань бота
const SystemSettingsTable = () => {
  // Отримуємо дані та дії зі стору
  const systemSettings = useBotStore((state) => state.systemSettings);
  const updateSetting = useBotStore((state) => state.updateSetting);
  const { isAllowed } = useAuth();

  // Перевіряємо, чи має юзер право редагувати налаштування бота
  const canEdit = isAllowed("bot:manage");

  const [editingKey, setEditingKey] = useState(null);
  const [editValue, setEditValue] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  // Функція ініціалізації редагування налаштування
  const startEditing = (setting) => {
    if (!canEdit) return;

    setEditingKey(setting.setting_key);
    setEditValue(setting.setting_value);
  };

  // Функція скасування редагування
  const cancelEditing = () => {
    setEditingKey(null);
    setEditValue("");
  };

  // Функція збереження редагування
  const saveEditing = async () => {
    if (!editValue.trim() || isSaving) return cancelEditing();

    const oldVal = systemSettings.find(
      (s) => s.setting_key === editingKey,
    )?.setting_value;
    if (oldVal === editValue) return cancelEditing();

    setIsSaving(true);
    const success = await updateSetting(editingKey, editValue);
    setIsSaving(false);

    if (success) {
      setEditingKey(null);
    }
  };

  // Обробник натискання клавіш
  const handleKeyDown = (e) => {
    if (e.key === "Enter") saveEditing();
    if (e.key === "Escape") cancelEditing();
  };

  return (
    <div id="system-settings-table" className="botsettings-table">
      <div className="table-title">
        <h4>Системні налаштування</h4>
      </div>
      <table>
        <thead>
          <tr>
            <th>Ключ</th>
            <th>Значення</th>
          </tr>
        </thead>
        <tbody>
          {[...systemSettings]
            .sort(
              (a, b) =>
                SettingsOrder.indexOf(a.setting_key) -
                SettingsOrder.indexOf(b.setting_key),
            )
            .map((setting) => {
            const isEditing = editingKey === setting.setting_key;

            return (
              <tr key={setting.setting_key}>
                <td title={setting.description}>
                  {SettingsNameMapper[setting.setting_key]}
                </td>

                <td
                  onDoubleClick={
                    canEdit && !isEditing ? () => startEditing(setting) : undefined
                  }
                  title={
                    !isEditing
                      ? canEdit
                        ? "Подвійний клік для редагування"
                        : "Тільки перегляд"
                      : ""
                  }
                >
                  {isEditing ? (
                    <input
                      type="text"
                      value={editValue}
                      onChange={(e) => setEditValue(e.target.value)}
                      onBlur={saveEditing}
                      onKeyDown={handleKeyDown}
                      disabled={isSaving}
                      autoFocus
                    />
                  ) : (
                    <span>{setting.setting_value}</span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SystemSettingsTable;
